import { Outlet } from "react-router-dom";
import SectionTabs from "./SectionTabs";

export default function DestinationLayout({ items, testId }) {
  return (
    <div data-testid={testId}>
      <SectionTabs items={items} />
      <Outlet />
    </div>
  );
}
